module.exports = __webpack_public_path__ + "img/jiangbei_banner.59fb585d.png";